
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable} from 'rxjs';
import {MyobContact} from '../models/myob-contacts.model';
import {catchError, map} from 'rxjs/operators';
import { throwError } from 'rxjs'; // only way to ge throwError to work.
import { DemoService } from './../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { GlobalFunctionsService } from './global-functions.service';




@Injectable()
export class MyobContactService {
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  myobCode: Object;
  customerItem: any;
  myobCustomer: any;


  constructor(private httpService: HttpClient,   private _demoService: DemoService, public toastr: HotToastService, public gfunc: GlobalFunctionsService) {
  };

  public getMyobContact(UID: number): Observable<MyobContact> {
    return this.httpService.get<MyobContact>(`${this.gfunc.sopNodeURL}/myob_customer/${UID}`).pipe(
      map(data => new MyobContact()),
      catchError(() => throwError('MyobContact not found'))
    );
  }

 public getAllMyobContacts(): Observable<MyobContact[]> {
    return this.httpService.get<MyobContact[]>(`${this.gfunc.sopNodeURL}/myob_customers`).pipe(
      map(data => data.map(data => new MyobContact().deserialize(data)))
    );
  }
   

  



/*
// *
// * :: Real Myob Contact/Customers return this.http.get('http://localhost:1050/api/myob/company/customers');
// *
// * :: USING CONNECTION SCRIPTS BELOW:: TODO::// Still need to model contact: Contacts[]??
*/

  getMyobCode(){
    this._demoService.getMyobCode().subscribe(
      data => { this.myobCode = data;
        this.toastr.success('MYOB handshake: shaken..! SOP we are connected...');
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  
  // uses demo services but calls to myob
 public getMyobCustomers(){
  return  this._demoService.getMyobCustomers().subscribe(
      data => { this.myobCustomers = data;
        let res = data[0];
  
         console.log(this.myobCustomers);
  
         // https://www.concretepage.com/questions/577
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.Items = data['Items'] ;
         console.log(this.Items);
        // this.Address = this.Items['Address'];
  
  // return this.myobCustomers;
  
  
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading Trace Types')
    );
  
  }


  public getMyobCustomer(UID){
    return  this._demoService.getMyobCustomer(UID).subscribe(
        data => { this.myobCustomer = data;
          let res = data[0];
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.customerItem = data['Item'] ;
           console.log(this.customerItem);
          // this.Address = this.Items['Address'];
    
    // return this.myobCustomers;
    
    
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
          console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
    
    }

}